var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0"},[_c('v-row',[_c('v-col',{staticClass:"mx-0 px-0 pt-0"},[_c('header-text-bg',{attrs:{"site":_vm.site,"text":_vm.tagDetail.name,"color":_vm.tagDetail.color}})],1)],1),_c('v-row',{staticClass:"mx-2",staticStyle:{"display":"flex","gap":"10px","margin-top":"-30px"}},[_c('v-btn',{staticClass:"rounded-lg",style:({
        flex: 1,
        backgroundColor: _vm.bgColorSelect('mission'),
        color: _vm.colorSelect('mission'),
        textTransform: 'none',
        fontWeight: 500,
        justifyContent: 'center',
      }),attrs:{"elevation":"5"},on:{"click":function($event){return _vm.changeType('mission')}}},[_vm._v(" "+_vm._s(_vm.$t("activity"))+" ")]),_c('v-btn',{staticClass:"rounded-lg",style:({
        flex: 1,
        backgroundColor: _vm.bgColorSelect('reward'),
        color: _vm.colorSelect('reward'),
        textTransform: 'none',
        fontWeight: 500,
        justifyContent: 'center',
      }),attrs:{"elevation":"5"},on:{"click":function($event){return _vm.changeType('reward')}}},[_vm._v(" "+_vm._s(_vm.$t("reward"))+" ")])],1),_c('v-row',[(_vm.type == 'mission')?_c('MyTagMission'):_vm._e(),(_vm.type == 'reward')?_c('MyTagReward'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }